import { db } from "../common/config/Firebase";

export const SET_TASKS_LOADING = 'SET_TASKS_LOADING';
export const SET_TASKS_DATA = 'SET_TASKS_DATA';
export const SET_TASK = 'SET_TASK';
export const DELETE_TASK = 'DELETE_TASK';
export const SET_CLIENT_SELECTED = 'SET_CLIENT_SELECTED'
export const SET_DATE_FILTER = 'SET_DATE_FILTER'
export const SET_SNAPSHOT = 'SET_SNAPSHOT'

const setTasksLoading = payload => (
    { type: SET_TASKS_LOADING, payload }
)

const setTasksData = payload => (
    { type: SET_TASKS_DATA, payload }
)

const setTaskData = payload => (
    { type: SET_TASK, payload }
)

const deleteTaskData = payload => (
    { type: DELETE_TASK, payload }
)

const setClientSelected = payload => (
    { type: SET_CLIENT_SELECTED, payload }
)

const setDateFilter = payload => (
    { type: SET_DATE_FILTER, payload }
)

const setSnapshot = payload => (
    { type: SET_SNAPSHOT, payload }
)

const collectionTask = db.collection('tasks')

export const getTasks = payload => {
    return (dispatch, getState) => {
        const dateFilter = getState().tasks.dateFilter
        const unsubscribe = getState().tasks.snapshot

        if (typeof unsubscribe === "function") {
            dispatch(setTasksData([]));
            unsubscribe();
        }

        dispatch(setTasksLoading({...payload, loading: true }));

        const snapshot = collectionTask
            .where("dateEntry", ">", getDateFilter({ dateFilter }).getTime())
            .onSnapshot(snapshot => {
                let dataAdd = {};
                let dataUpdate = {};
                let dataDelete = {};

                snapshot.docChanges().forEach(change => {
                    if (change.type === "added") {
                        dataAdd[change.doc.id] = change.doc.data();
                    } else if (change.type === "modified") {
                        dataUpdate[change.doc.id] = change.doc.data();
                    } else if (change.type === "removed") {
                        dataDelete[change.doc.id] = change.doc.data();
                    }
                });

                if (getState().tasks.data.length === 0) {
                    dispatch(setTasksData(dataAdd));
                } else {
                    Object.entries(dataAdd).forEach(([key, value]) => dispatch(setTaskData({ task: key, data: value })));
                    Object.entries(dataUpdate).forEach(([key, value]) => dispatch(setTaskData({ task: key, data: value })));
                    Object.entries(dataDelete).forEach(([key, value]) => dispatch(deleteTaskData({ task: key })));
                    dispatch(setTasksLoading({...payload, loading: false }));
                }
            })

            dispatch(setSnapshot({...payload, snapshot }))
    }
}

export const selectClient = ({ client }) => {
    return dispatch => {
        const clientSelected = {...client, clientName: client.name }
        dispatch(setClientSelected({ clientSelected }))
    }
}

export const selectDateFilter = ({ dateFilter }) => {
    return dispatch => {
        dispatch(setDateFilter({ dateFilter }))
    }
}

const getDateFilter = ({ dateFilter }) => {
    const date = new Date()

    if (dateFilter === 0) {
        date.setMonth(date.getMonth() - 3)
    } else if (dateFilter === 1) {
        date.setMonth(date.getMonth() - 6)
    } else if (dateFilter === 2) {
        date.setMonth(date.getMonth() - 12)
    } else {
        date.setMonth(date.getMonth() - 1000)
    }

    console.log(date)
    return date
}
